import styled, { css } from 'styled-components';
import { THEME } from '../../../../themes';
import {
  Body2Font, HeadlineFont, Subtitle1Font, Title2Font,
} from '../../../../themes/fonts';
import { ASSETS, FLUENT_UI_EMOJIS } from '../../../../assets';
import BaseButton from '../../../Common/Buttons/perfect-base-button/perfect-base-button.component';

export const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${THEME.SPACING.BASE};
  background-color: ${THEME.COLORS.PURE_WHITE};
  border-radius: ${THEME.RADIUS.CURVY};
  width: 300px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
  padding: ${THEME.SPACING.BASE} ${THEME.SPACING.MEDIUM};
`;

export const PlanDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${THEME.SPACING.BASE};
`;

export const PlanCTAWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${THEME.SPACING.BASE};
`;

export const PlanIcon = styled.img`
  width: 64px;
  height: 64px;
`;

export const Title = styled.div<{ $withQuotes?: boolean }>`
  ${HeadlineFont};

  ${({ $withQuotes }) => $withQuotes &&
    css`
      ::before {
        content: '"';
      }
      ::after {
        content: '"';
      }
    `}
`;

export const Description = styled.div`
  ${Subtitle1Font};
  opacity: ${THEME.OPACITY.MED};
`;

export const PriceWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  gap: ${THEME.SPACING.MICRO};
`;

export const PriceAmount = styled.div`
  ${Title2Font};
  font-weight: bold;
`;

export const PriceInterval = styled.div`
  ${Body2Font};
  font-weight: bold;
`;

export const MonthlyCredits = styled.div`
  display: flex;
  align-items: center;
  gap: ${THEME.SPACING.MICRO};
  ${Subtitle1Font};
`;

export const UserSeats = styled.div`
  display: flex;
  align-items: center;
  gap: ${THEME.SPACING.MICRO};
  ${Subtitle1Font};
`;

export const UpgradeNowButton = styled(BaseButton)`
  background-color: ${THEME.COLORS.ACCENT};
`;

const commonIconStyles = css`
  width: 24px;
  height: 24px;
`;

export const CoinIcon = styled.img.attrs(() => ({
  src: ASSETS.COIN,
  alt: 'credits',
}))`
  ${commonIconStyles}
`;

export const CoinStackIcon = styled.img.attrs(() => ({
  src: ASSETS.COIN_STACK,
  alt: 'credits',
}))`
  ${commonIconStyles}
`;

export const LockIcon = styled(FLUENT_UI_EMOJIS.LOCKED)`
  ${commonIconStyles}
`;

export const SeatIcon = styled(FLUENT_UI_EMOJIS.SEAT)`
  ${commonIconStyles}
`;
